import merge3way from '3-way-merge';
import { reconcileIncomingStatus } from 'src/stores/status/statusWrites';

import { Appointment } from 'src/models/appointment';
import { Document } from 'src/models/document';
import { IdoJsonModel } from 'src/models/ido';
import { Mail } from 'src/models/mail';
import { Memo } from 'src/models/memo';
import { Message } from 'src/models/message';
import { Note } from 'src/models/note';
import { PhoneCall } from 'src/models/phoneCall';
import { Task } from 'src/models/task';

class AggregateMerger {
	public static copyNonMergeableProperties(
		actualAggregate: Appointment | Document | IdoJsonModel | Mail | Memo | Message | Note | PhoneCall | Task | null,
		newlyLoadedAggregate:
			| Appointment
			| Document
			| IdoJsonModel
			| Mail
			| Memo
			| Message
			| Note
			| PhoneCall
			| Task
			| null
	): Appointment | Document | IdoJsonModel | Mail | Memo | Message | Note | PhoneCall | Task | null {
		if (actualAggregate !== null && newlyLoadedAggregate !== null) {
			if ('statusButton' in actualAggregate && 'statusButton' in newlyLoadedAggregate) {
				const incomingStatusButton = newlyLoadedAggregate.statusButton;
				if (incomingStatusButton === undefined) {
					actualAggregate.statusButton = incomingStatusButton;
				} else {
					const reconciledStatus =
						'aggregateId' in actualAggregate
							? reconcileIncomingStatus(actualAggregate.aggregateId, incomingStatusButton.status)
							: incomingStatusButton.status;
					actualAggregate.statusButton = { ...incomingStatusButton, status: reconciledStatus };
				}
			}
			if ('idoButton' in actualAggregate && 'idoButton' in newlyLoadedAggregate) {
				actualAggregate.idoButton = newlyLoadedAggregate.idoButton;
			}
			if ('archivButton' in actualAggregate && 'archivButton' in newlyLoadedAggregate) {
				actualAggregate.archivButton = newlyLoadedAggregate.archivButton;
			}
			if ('globalizationButton' in actualAggregate && 'globalizationButton' in newlyLoadedAggregate) {
				actualAggregate.globalizationButton = newlyLoadedAggregate.globalizationButton;
			}
			if ('spoingButton' in actualAggregate && 'spoingButton' in newlyLoadedAggregate) {
				actualAggregate.spoingButton = newlyLoadedAggregate.spoingButton;
			}
			if ('taskButton' in actualAggregate && 'taskButton' in newlyLoadedAggregate) {
				actualAggregate.taskButton = newlyLoadedAggregate.taskButton;
			}
			if ('historyEntries' in actualAggregate && 'historyEntries' in newlyLoadedAggregate) {
				actualAggregate.historyEntries = newlyLoadedAggregate.historyEntries;
			}
			if (
				'desktopPanelDocumentModelVersions' in actualAggregate &&
				'desktopPanelDocumentModelVersions' in newlyLoadedAggregate
			) {
				actualAggregate.desktopPanelDocumentModelVersions =
					newlyLoadedAggregate.desktopPanelDocumentModelVersions;
			}
		}

		return actualAggregate;
	}

	public static merge(
		initiallyLoadedAggregate:
			| Appointment
			| Document
			| IdoJsonModel
			| Mail
			| Memo
			| Message
			| Note
			| PhoneCall
			| Task
			| null,
		actualAggregate: Appointment | Document | IdoJsonModel | Mail | Memo | Message | Note | PhoneCall | Task | null,
		newlyLoadedAggregate: Appointment | Document | IdoJsonModel | Mail | Memo | Message | Note | PhoneCall | Task
	): Appointment | Document | IdoJsonModel | Mail | Memo | Message | Note | PhoneCall | Task | null {
		if (actualAggregate !== null && 'aggregateId' in actualAggregate && 'aggregateId' in newlyLoadedAggregate) {
			if (actualAggregate.aggregateId !== newlyLoadedAggregate.aggregateId) {
				return actualAggregate;
			}
		} else if (actualAggregate === null) {
			return newlyLoadedAggregate;
		}

		actualAggregate = AggregateMerger.copyNonMergeableProperties(
			actualAggregate,
			newlyLoadedAggregate
		) as unknown as Appointment | Document | IdoJsonModel | Mail | Memo | Message | Note | PhoneCall | Task | null;

		return merge3way(initiallyLoadedAggregate, actualAggregate, newlyLoadedAggregate);
	}
}

export { AggregateMerger };
